<section class="curation-modal dynamic-modal-content-container">
  <span class="curation-modal-title dynamic-modal-content Auto_Popup_Text">{{title}}</span>
  <span class="curation-modal-content dynamic-modal-content Auto_Popup_Text">{{content}}</span>
</section>